import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  Tooltip,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material'

import { tableCellClasses } from '@mui/material/TableCell'
import RefreshIcon from '@mui/icons-material/Refresh'
import { useDispatch, useSelector } from 'react-redux'
import { useStyles } from '../CaseDiagnosisStyles'
import { RootState } from '../../../reducers'
import { Clear as ClearIcon } from '@mui/icons-material'
import LaunchIcon from '@mui/icons-material/Launch'
import { styled } from '@mui/material/styles'
import TableHead from '@mui/material/TableHead'

export default function PatientInformation({ isReadOnlyMode, handleRefreshCases }) {
  const classes = useStyles()
  const trfData = useSelector((state: RootState) => state.addTrfInfo)
  const procedureData = useSelector((state: RootState) => state.getFilterProcedureCodeData)
  const clinicalInfo = useSelector((state: RootState) => state.addClinicalInfo)
  const { historyData, fetchHistoryInProgress } = useSelector((state: RootState) => state.setPatientHistory)
  const { caseNumber, procedureCodeId } = useSelector((state: RootState) => state.getCaseData)
  const filterUserResults = procedureData.procedureCodeMap.filter((value) => {
    return value.id == procedureCodeId
  })
  const caseType = filterUserResults[0]?.display ? filterUserResults[0]?.display : ''
  const [open, setOpen] = React.useState(false)
  const getRefreshClassName = () => (isReadOnlyMode ? `${classes.disabledRefreshIcon} ` : `${classes.refreshIcon}`)

  const handleClose = () => {
    setOpen(false)
  }

  const patientHistoryOpen = () => {
    setOpen(true)
  }

  const handleDob = (dob) => {
    return dob.slice(0, 10)
  }

  const getAge = (dob) => {
    const today = new Date()
    const birthDate = new Date(dob)
    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#9bbbcc',
      //color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }))
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }))

  return (
    <>
      <Box>
        <Dialog
          open={open}
          fullWidth
          maxWidth={'xl'}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle className={classes.dialogTitle}>Patient History</DialogTitle>
          <DialogContent style={{ padding: '0px 0px 0px 0px' }}>
            {historyData && (
              <Box
                sx={{
                  height: '60%',
                  width: '100%',
                  padding: '0px 0px 0px 0px',
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#9bbbcc',
                    fontWeight: '600',
                  },
                  '& .MuiDataGrid-columnHeader--moving': {
                    backgroundColor: 'transparent !important',
                  },
                }}
              >
                <Table stickyHeader key="patientHistory" size="small">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell style={{ width: '8%' }}>Barcode</StyledTableCell>
                      <StyledTableCell style={{ width: '10%' }}>Receipt Date</StyledTableCell>
                      <StyledTableCell>Diagnosis</StyledTableCell>
                      <StyledTableCell style={{ width: '12%' }}>Name</StyledTableCell>
                      <StyledTableCell style={{ width: '10%' }}>DOB</StyledTableCell>
                      <StyledTableCell style={{ width: '6%' }}>Gender</StyledTableCell>
                      <StyledTableCell style={{ width: '10%' }}>Address Line1</StyledTableCell>
                      <StyledTableCell style={{ width: '10%' }}>Phone</StyledTableCell>
                      <StyledTableCell style={{ width: '10%' }}>Cnt Name</StyledTableCell>
                      <StyledTableCell style={{ width: '10%' }}>Practice Name</StyledTableCell>
                      <StyledTableCell style={{ width: '10%' }}>Practice Address</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {historyData &&
                      historyData.payload &&
                      historyData.payload.length > 0 &&
                      historyData.payload.map((historyDataRow, index) => (
                        <StyledTableRow key={index}>
                          <TableCell>
                            <label>{historyDataRow.trfbarcode}</label>
                          </TableCell>
                          <TableCell>
                            <label>{handleDob(historyDataRow.TrfReceiptDate)}</label>
                          </TableCell>
                          <TableCell>
                            <label>{historyDataRow.Diagnosis}</label>
                          </TableCell>
                          <TableCell>
                            <label>
                              {historyDataRow.PatLastName}, {historyDataRow.PatFirstName}
                            </label>
                          </TableCell>
                          <TableCell>
                            <label>
                              {historyDataRow.PatDOB && historyDataRow.PatAge !== 0
                                ? handleDob(historyDataRow.PatDOB)
                                : ''}
                            </label>
                          </TableCell>
                          <TableCell>
                            <label>{historyDataRow.patsex}</label>
                          </TableCell>
                          <TableCell>
                            <label>{historyDataRow.PraAddressLine1}</label>
                          </TableCell>
                          <TableCell>
                            <label>{historyDataRow.patphone}</label>
                          </TableCell>
                          <TableCell>
                            <label>
                              {historyDataRow.CntLastName}, {historyDataRow.CntFirstName}
                            </label>
                          </TableCell>
                          <TableCell>
                            <label>{historyDataRow.PraName}</label>
                          </TableCell>
                          <TableCell>
                            <label>{historyDataRow.PraAddressLine1}</label>
                          </TableCell>
                        </StyledTableRow>
                      ))}
                    {historyData && historyData.payload && historyData.payload.length === 0 && (
                      <StyledTableRow>
                        <TableCell colSpan={11} align="center">
                          <label>No patient records are found</label>
                        </TableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}
          </DialogContent>
          <DialogActions className={classes.buttonActions}>
            <Button
              className={`${classes.buttonMargin}`}
              onClick={handleClose}
              variant="outlined"
              endIcon={<ClearIcon />}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
      <Box className={classes.patientInformation}>
        <div className={classes.caseDetailsTitle}>
          Case Details
          <div style={{ float: 'right' }} onClick={(event) => handleRefreshCases()}>
            <Tooltip title="Sync data between LabOs and Premeris for this particular case">
              <RefreshIcon className={getRefreshClassName()} />
            </Tooltip>
          </div>
        </div>
        <div className={classes.reportTitle}>
          <h3 style={{ margin: '5px 0px 10px 0px' }}>Patient Information </h3>
          <Table key="clinicalInfoTable" size="small" style={{ width: '90%' }}>
            <TableBody>
              <StyledTableRow>
                <TableCell colSpan={2}>
                  <label className={classes.reportDate}>
                    <a style={{ fontWeight: '600', fontSize: '14px', cursor: 'pointer' }} onClick={patientHistoryOpen}>
                      {trfData && trfData?.patientInfo
                        ? trfData?.patientInfo.PatLastName + ', ' + trfData?.patientInfo.PatFirstName
                        : ''}
                      <Tooltip title="View patient history">
                        <LaunchIcon style={{ color: '#10688d', verticalAlign: 'middle', paddingLeft: '4px' }} />
                      </Tooltip>
                    </a>
                  </label>
                </TableCell>
              </StyledTableRow>
              <StyledTableRow>
                <TableCell colSpan={2}>
                  DOB :{' '}
                  <label className={classes.reportDate} style={{ paddingRight: '30px' }}>
                    {trfData &&
                      trfData?.patientInfo &&
                      trfData?.patientInfo?.PatDOB &&
                      trfData?.patientInfo?.PatAge !== 0 &&
                      handleDob(trfData?.patientInfo?.PatDOB)}
                  </label>
                  Age :
                  <label className={classes.reportDate}>
                    {trfData && trfData?.patientInfo && trfData?.patientInfo?.PatAge !== 0
                      ? trfData?.patientInfo?.PatAge
                      : ''}
                  </label>
                </TableCell>
              </StyledTableRow>
              <StyledTableRow>
                <TableCell>State</TableCell>
                <TableCell>
                  <label className={classes.reportDate}>{trfData?.patientInfo?.PatState}</label>
                </TableCell>
              </StyledTableRow>
              <StyledTableRow>
                <TableCell>Case #</TableCell>
                <TableCell>
                  <label className={classes.reportDate}>{caseNumber}</label>
                </TableCell>
              </StyledTableRow>
              <StyledTableRow>
                <TableCell>Case Type</TableCell>
                <TableCell>
                  <label className={classes.reportDate}>{caseType}</label>
                </TableCell>
              </StyledTableRow>
              <StyledTableRow>
                <TableCell>Biopsy</TableCell>
                <TableCell>
                  <label className={classes.reportDate}>
                    {trfData && trfData?.trfInfo?.TrfReceiptDate && handleDob(trfData?.trfInfo?.TrfProcedureDate)}
                  </label>
                </TableCell>
              </StyledTableRow>
              <StyledTableRow>
                <TableCell>Received</TableCell>
                <TableCell>
                  <label className={classes.reportDate}>
                    {trfData && trfData?.trfInfo?.TrfReceiptDate && handleDob(trfData?.trfInfo?.TrfReceiptDate)}
                  </label>
                </TableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </div>
        <div className={classes.reportTitle}>
          <h3 style={{ margin: '5px 0px 10px 0px' }}>Clinical Information </h3>
        </div>
        <div className={classes.clinicalInfo}>
          <Table stickyHeader key="clinicalInfoTable" size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell style={{ width: '60%' }}>Order Parameters</StyledTableCell>
                <StyledTableCell style={{ width: '40%' }}>Value</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {clinicalInfo &&
                clinicalInfo.payload &&
                clinicalInfo.payload.length > 0 &&
                clinicalInfo.payload.map((clinicalDataItem, index) => (
                  <StyledTableRow key={index}>
                    <TableCell style={{ padding: '6px' }}>
                      <label>{clinicalDataItem.liname}</label>
                    </TableCell>
                    <TableCell style={{ padding: '6px' }}>
                      <label className={classes.reportDate}>{clinicalDataItem.livalue}</label>
                    </TableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
        </div>
      </Box>
    </>
  )
}
